(function () {
  'use strict';

  var RESTRICTED_TAG = 'nincs-standard-szallitas';
  var DISABLED_CLASS = 'standard-shipping-disabled';
  var STANDARD_ID = 'standard-shipping-option-div';
  var ACTIVE_CLASS = 'ft-options-active';
  var FALLBACK_IDS = ['delivery-option-div', 'pickup-option-div'];
  var TAG_CACHE_KEY = 'vk_ssl_tag_cache';
  var LAST_RESULT_KEY = 'vk_ssl_last_restricted';

  var productTagCache = {};

  // Fetching the product tags (/products/{handle}.js) is the main slow factor. Once
  // fetched for a product, we also store it in localStorage, so a subsequent page
  // load doesn't need to hit the network again for the same product.
  function readTagCache() {
    try {
      return JSON.parse(localStorage.getItem(TAG_CACHE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeTagCache(handle, tags) {
    try {
      var cache = readTagCache();
      cache[handle] = tags;
      localStorage.setItem(TAG_CACHE_KEY, JSON.stringify(cache));
    } catch (e) {
      // localStorage not available (e.g. private mode) -> silently skip
    }
  }

  function readLastRestricted() {
    try {
      return localStorage.getItem(LAST_RESULT_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function writeLastRestricted(restricted) {
    try {
      localStorage.setItem(LAST_RESULT_KEY, restricted ? '1' : '0');
    } catch (e) {
      // no-op
    }
  }

  function getHandleFromUrl(url) {
    if (!url) return null;
    try {
      var path = url.split('?')[0];
      var parts = path.split('/').filter(Boolean);
      var idx = parts.indexOf('products');
      return idx > -1 && parts[idx + 1] ? parts[idx + 1] : null;
    } catch (e) {
      return null;
    }
  }

  function getProductTags(handle) {
    if (!handle) return Promise.resolve([]);
    if (productTagCache.hasOwnProperty(handle)) {
      return Promise.resolve(productTagCache[handle]);
    }
    var persisted = readTagCache();
    if (persisted.hasOwnProperty(handle)) {
      productTagCache[handle] = persisted[handle];
      return Promise.resolve(persisted[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('product fetch failed: ' + handle);
        return res.json();
      })
      .then(function (product) {
        var tags = product.tags || [];
        productTagCache[handle] = tags;
        writeTagCache(handle, tags);
        return tags;
      })
      .catch(function (err) {
        console.warn('[standard-shipping-lock] Nem sikerült lekérni a termék címkéit:', handle, err);
        return [];
      });
  }

  function cartHasRestrictedProduct() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var handles = [];
        (cart.items || []).forEach(function (item) {
          var handle = getHandleFromUrl(item.url);
          if (handle && handles.indexOf(handle) === -1) handles.push(handle);
        });
        return Promise.all(handles.map(getProductTags));
      })
      .then(function (tagLists) {
        return tagLists.some(function (tags) {
          return tags.indexOf(RESTRICTED_TAG) !== -1;
        });
      })
      .catch(function (err) {
        console.warn('[standard-shipping-lock] Nem sikerült lekérni a kosarat:', err);
        return false;
      });
  }

  // The widget sometimes keeps multiple instances of the "Standard házhozszállítás"
  // button in the DOM at once (a hidden/inactive earlier render + the visible current
  // one), so EVERY matching element needs to be handled, not just the first.
  function findStandardRows() {
    return Array.prototype.slice.call(document.querySelectorAll('#' + STANDARD_ID));
  }

  function switchAwayIfActive(row, container) {
    if (!row.classList.contains(ACTIVE_CLASS) || !container) return;
    for (var i = 0; i < FALLBACK_IDS.length; i++) {
      var fallback = container.querySelector('#' + FALLBACK_IDS[i]);
      if (fallback) {
        fallback.click();
        return;
      }
    }
  }

  // The button itself (#standard-shipping-option-div) just sits inside a flex cell
  // (.ft-options-cell); if we only hide it, the cell keeps its place and an empty
  // gap remains in the row. So the parent cell needs to be hidden instead.
  function setRowDisabled(row, disabled) {
    if (!row) return;
    var cell = row.closest('.ft-options-cell') || row.parentElement;
    var container = row.closest('.ft-options-container');
    if (!cell) return;
    if (disabled) {
      switchAwayIfActive(row, container);
    }
    cell.classList.toggle(DISABLED_CLASS, disabled);
  }

  var applyInProgress = false;
  var applyQueued = false;

  function applyStandardShippingLock() {
    if (applyInProgress) {
      applyQueued = true;
      return;
    }
    var rows = findStandardRows();
    if (!rows.length) return; // the widget isn't (or isn't yet) in the DOM

    // Apply the last known decision immediately, without waiting on the network,
    // so the Standard option doesn't flash while the fresh check runs.
    var lastKnown = readLastRestricted();
    rows.forEach(function (row) {
      setRowDisabled(row, lastKnown);
    });

    applyInProgress = true;
    cartHasRestrictedProduct()
      .then(function (restricted) {
        writeLastRestricted(restricted);
        rows.forEach(function (row) {
          setRowDisabled(row, restricted);
        });
      })
      .finally(function () {
        applyInProgress = false;
        if (applyQueued) {
          applyQueued = false;
          applyStandardShippingLock();
        }
      });
  }

  // Style for fully hiding it
  var style = document.createElement('style');
  style.textContent =
    '.' + DISABLED_CLASS + ' {' +
    '  display: none !important;' +
    '}';
  document.head.appendChild(style);

  // Re-check when the widget re-renders (e.g. when the shipping method changes)
  var debounceTimer = null;
  var observer = new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(applyStandardShippingLock, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Re-check after cart operations (add/change/update/clear)
  var originalFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var result = originalFetch.apply(this, args);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      result.then(function () { setTimeout(applyStandardShippingLock, 200); }).catch(function () {});
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyStandardShippingLock);
  } else {
    applyStandardShippingLock();
  }

  // Manual re-check from other scripts, if needed:
  window.standardShippingLockRefresh = applyStandardShippingLock;
})();
